import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { likesPlaceholder } from '../../constants/placeholder';
import CustomFollowerRange from '../../components/CustomFollowerRange';
import { useSetRangeDefaultValue, dealwithRangeDataWithNewFormat } from '../../hooks/init';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function LikesRange({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
}: SingleCommonType) {
  const { rangeValue, setRangeValue, followerRef, options, diffClassName } =
    useSetRangeDefaultValue({
      defaultValue,
      filterValue,
      defaultKey: 'likes',
      oriDefaultFilter,
      backOriDefaultValue,
      options: [
        { text: 'All', value: '-' },
        { text: '0 ~ 500', value: '0-0.5' },
        { text: '500 ~ 1000', value: '0.5-1' },
        { text: '1000 ~ 10000', value: '1-10' },
        { text: '> 10000', value: '10-' },
      ],
      dealwithDateFunc: dealwithRangeDataWithNewFormat,
    });

  const { formatMessage } = useIntl();
  useEffect(() => {
    const showHeader = followerRef.current?.buttonElement?.(rangeValue);
    const data = [];
    if (rangeValue !== '-') {
      const [start, end] = rangeValue.split('-');
      // 新格式: 使用 start/end
      type DataItem = { start: number; end?: number };
      const dataItem: DataItem = {
        start: Number(start) * 1000,
      };
      if (end !== '') {
        dataItem.end = Number(end) * 1000;
      }
      data.push(dataItem);
    }

    onChange?.(
      'likesRange',
      commonBackInfo({ likes: data }, { likesRange: showHeader }),
    );
  }, [rangeValue, formatMessage]);

  return (
    <div className={diffClassName}>
      <CustomFollowerRange
        lang={lang}
        ref={followerRef}
        options={options}
        setRangeValue={setRangeValue}
        rangeValue={rangeValue}
        placeholder={likesPlaceholder}
        pointKey={FilterButtonPoint.likesRange}
      ></CustomFollowerRange>
    </div>
  );
}
